import React, { Component } from 'react';
import {Grid, Typography, Button, Paper, TextField} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import { Settings } from '@material-ui/icons';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import CompetencyQuestion from './CompetencyQuestion';


export default class AssessmentFormCA extends Component {

    constructor(props) {
        super(props);
        
        this.state = {  
            comp_q_array: [],  
            division: '',
            assessment_group: '',
            score_obj: {},
            querying: true,
            overall_score: 1,
            comment: "",
            has_comment: false,
            writing: false,
            partially_complete: false,
            all_answered: false,
            error: false,
            error_message: '',
            primary_button_enabled: false,
            primary_button_text: 'Submit Assessment',
            is_super_admin_override: false,
            selecting_assessor: false,
            show_assessors: false,
            search_name:'',
            search_number: '',
            search_ready:false,
            searching:false,
            assessors_array: [],
            assessor_name: this.props.employee_name,
            assessor_number: this.props.employee_number
        };
        this.pattern = new RegExp("^[a-zA-Z0-9 `'?,.;!]+$");
        this.datasheetFieldSpecs = [
            { field: 'select', headerName: ' ', width: 120, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <Button 
                    onClick={()=>this.updateAssessor(parms)} 
                    color='primary'
                    variant='outlined'
                    disabled={!this.state.search_ready}
                >
                    Select
                    {/* <HowToRegTwoTone/> */}
                </Button>
            )},
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store_code', headerName: 'Store Code', width: 120, sortable:false},
            { field: 'store', headerName: 'Store', width: 160},
            { field: 'region', headerName: 'Region', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125}
        ]

        this.comp_ref = [];

    }

    componentDidMount = () => {
        //   check whether this is a capture of someone else's assessment by a super_admin
        if ((this.props.assessment.assessment_type_id==="M"&&(this.props.assessment.reports_to_rom!==this.props.rom_code))||(this.props.assessment.requires_nomination&&(this.props.assessment.nominated_assessor_id!==this.props.employee_number))) {
            this.setState({is_super_admin_override:true})
        }

        Gserv.sendCommand('query_competency_questions',this.props.gwt,{
            employee_number: this.props.assessment.assessee_employee_id
        })
        .then(reply => {
            // console.log('query_competency_questions reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_competency_questions) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.", querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_competency_questions) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.", querying:false});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({error_message:"No competencies are mapped to this assessment group.", querying:false});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.", querying:false})
                }
            } else {
                this.setState({comp_q_array:reply.Records, division: reply.Records[0].division, assessment_group: reply.Records[0].assessment_group, querying:false});
            }
        });

    };

    handleCommentChange = (e) => {
        // console.log('e.target.value :>> ', e.target.value);
        if (!e.target.value){
            this.setState({comment:"", has_comment:false});
        } else if (this.pattern.test(e.target.value)&&(e.target.value.length<=500)){
            if (e.target.value.length>=1){
                this.setState({comment:e.target.value, partially_complete:true,has_comment:true});
            } else {
                this.setState({comment:e.target.value, partially_complete:true,has_comment:false});
            }
        }
    }

    handleScoreUpdate = (update_obj) => {
        // console.log('update_obj :>> ', update_obj);
        let new_score = this.state.score_obj;
        let all_answered = false;
        if (update_obj.answered){
            new_score[update_obj.competency_id] = {
                area: update_obj.area,
                division: update_obj.division,
                competency: update_obj.competency,
                score: Number(update_obj.score)
            }
            if (Object.keys(new_score).length === this.state.comp_q_array.length){
                all_answered = true;
            }
        } else {
            delete new_score[update_obj.competency_id];
        }

        this.setState({score_obj: new_score, partially_complete:true, all_answered: all_answered});
    }
   
    resetMe = () => {
        //reset each underying
        this.setState({
            score_obj: {},
            overall_score: 1,
            comment: "",
            has_comment: false,
            writing: false,
            partially_complete: false,
            all_answered: false,
            error: false,
            error_message: '',
            primary_button_enabled: false,
            primary_button_text: 'Submit Assessment',
            is_super_admin_override: false,
            selecting_assessor: false,
            show_assessors: false,
            search_name:'',
            search_number: '',
            search_ready:false,
            searching:false,
            assessors_array: [],
            assessor_name: this.props.employee_name,
            assessor_number: this.props.employee_number
        });

        for (var i = 0; i < this.comp_ref.length; i++){
            this.comp_ref[i].current.resetMe();
        }

    }

    changeAssessor = () => {
        if (this.props.super_admin){
            this.setState({selecting_assessor:true})
        }
    }

    updateAssessor = (parms) => {
        // console.log('parms.row :>> ', parms.row);
        if (this.props.super_admin){
            this.setState({selecting_assessor:false,search_name:'',search_ready:false,searching:false,error:false,error_message:'',show_assessors:false, assessor_name: parms.row.name, assessor_number:parms.row.id})
        }
    }

    runSearch = (e) => {
        e.preventDefault();
        // console.log('e :>> ', e);

        if (!this.state.search_name&&!this.state.search_number){return}

        this.setState({searching:true, search_ready:false});
        Gserv.sendCommand('find_users_for_group_registry',this.props.gwt,{
            search_string: this.state.search_name? this.state.search_name : this.state.search_number,
            search_type: this.state.search_name? 'surname' : 'employee number',
            assessment: this.state.current_record
        })
        .then(reply => {
            // console.log('search reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (find_users_for_group_registry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (find_users_for_group_registry) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({error_message:"No employee records found matching the search."});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."})
                }
            } else {
                if (reply.Records){
                    let record_array = reply.Records;
                    let DOE = null;
                    for (var i=0;i<record_array.length;i++){
                        DOE = new moment(record_array[i].date_of_entry).format("YYYY-MM-DD");
                        record_array[i].date_of_entry = DOE;
                    }
                }
                this.setState({assessors_array:reply.Records,show_assessors:true,searching:false,search_ready:true});

            }
        });

    }

    submitMe = () => {
        this.setState({writing:true});
        const payload = {
            score_obj: this.state.score_obj,
            overall_score : this.state.overall_score,
            comment : this.state.comment,
            assessment : this.props.assessment,
            assessor_employee_number : this.state.assessor_number,
            assessor_not_submitter : this.state.assessor_number !== this.props.employee_number ? true : false
        }
        Gserv.sendCommand('create_ca_assessment',this.props.gwt,payload)
        .then(reply=>{
            if (reply.error){
                console.log('error on return from Gserv (create_ca_assessment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (create_ca_assessment) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
            } else {
                this.props.resetParentState();             
            }
        });
    }

    render() {
        const assmt = this.props.assessment;

        return (
            <div>

                {!this.state.writing&&!this.state.querying&&    
                <Paper
                    elevation={3}
                >
                <Grid
                    container
                    direction='column'
                    // justifyContent='center'
                    // alignContent='center'
                    style={{padding:'25px'}}
                >

                    <Typography
                        variant='h5'
                        color='primary'
                        style={{paddingTop:15, textAlign:'left'}}
                    >
                        Competency Assessment <b>(CA)</b>
                    </Typography>
                    {/* <Typography
                        style={{textAlign:'left',marginBottom:'5px'}}
                    >
                        Assessment
                    </Typography>      */}
                    <br/>

                    <Typography
                        style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                    >
                        {assmt.assessment_type} assessment of competencies for <b>{assmt.assessee_name}</b> ({assmt.job_title}) for cycle <b>{assmt.cycle_code}</b><br/>
                        {this.state.assessment_group&&
                        <span>
                            Division: <b>{this.state.division}</b>  &nbsp;&nbsp; Assessment Group: <b>{this.state.assessment_group}</b>
                        </span>}
                    </Typography>

                    <br/>                

                    <Typography
                        color='primary'
                    >
                        <b><i>Please answer the following questions with respect to {assmt.assessment_type_id==="S"? "your" : assmt.assessee_name + "'s"} relevant competencies</i></b>
                    </Typography>
                    
                    <hr style={{width:'100%'}}/>   

                    {/* Map comp_q_array here... */}
                    {this.state.comp_q_array.map((item,i) => {
                        this.comp_ref[i] = React.createRef();
                        return(
                        <CompetencyQuestion 
                            competency={item}
                            updateScore={this.handleScoreUpdate}
                            key={i}
                            ref={this.comp_ref[i]}
                        />
                        )
                    })}                  

                    {/* Hide for now... may want to bring back overall score, depending on feedback on review...        
                    {this.props.admin&&
                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='center'
                        style={{width:'1050px'}}
                    >
                        &nbsp;&nbsp;
                        <Card
                            elevation={2}
                            style={{padding:'10px', width:'400px'}}
                        >
                            <Typography
                                // variant='h5'
                                style={{textAlign:'left'}}
                            >
                                Overall Potential Score:  
                            </Typography>

                            <Typography
                                color={this.state.overall_score===1? 'secondary' : (this.state.overall_score===2? 'initial' : 'primary')}
                                style={{alignSelf:'center',fontSize:40}}
                            >
                                <b>{this.state.overall_score}</b>
                            </Typography>
                        </Card>
                    </Grid>} */}

                    {/* {this.props.admin&&    
                    <hr style={{width:'100%'}}/>} */}

                    <TextField 
                        id={'comment'}
                        type={'text'}
                        fullWidth={true}
                        label={'Comment'}
                        inputProps={{maxLength:500,minLength:10}}
                        autoCapitalize='off'
                        autoComplete='off'
                        autoCorrect='off'
                        required={true}
                        onChange={this.handleCommentChange}
                        value={this.state.comment}
                        disabled={this.writing}
                        variant='standard'
                    />

                    <Grid 
                        container
                        direction='row'
                        style={{marginTop:'15px'}}
                        // justifyContent='center'
                        alignItems='center'
                        
                    >            
                        <Typography style={{textAlign:'left'}}>
                            Assessor: <b>{this.state.assessor_name}</b> [{this.state.assessor_number}] 
                        </Typography>
                        {this.state.is_super_admin_override&&
                        <Button 
                            variant="contained"
                            color='primary'
                            style={{marginLeft:'10px'}}
                            onClick={this.changeAssessor}
                            disabled={this.state.selecting_assessor}
                        >
                            Change
                        </Button>}
                    </Grid>
                    
                    {/* ** Start - Assessor Selection Panel ** */}
                    {this.state.selecting_assessor&&
                    <div>    
                        <hr/>    
                        <Typography
                            color='primary'
                            style={{paddingTop:10}}
                        >
                            Select Assessor
                        </Typography>
                        <Grid
                            container
                            direction='column'
                            justifyContent='space-evenly'
                            alignContent='center'
                            style={{padding:15}}
                        >
    
                            <form onSubmit={this.runSearch}>
                                <TextField
                                    autoComplete="off"
                                    autoCorrect="off"
                                    autoCapitalize="on"
                                    autoFocus={true}
                                    label={'Surname Search'}
                                    variant='outlined'
                                    value={this.state.search_name}
                                    onChange={(e) => {
                                        const outText = e.target.value.replace(/[^ A-Za-z]+/g, '').toUpperCase();
                                        const can_sub = (outText.length>2);
                                        this.setState({search_name: outText, search_number: '', search_ready: can_sub, error: false});
                                    }}
                                    // required
                                    style={{marginBottom:'10px', marginRight:'10px'}}
                                    disabled={this.state.searching}
                                />
                                <TextField
                                    autoComplete="off"
                                    autoCorrect="off"
                                    autoCapitalize="off"
                                    autoFocus={false}
                                    label={'Employee # Search'}
                                    variant='outlined'
                                    value={this.state.search_number}
                                    onChange={(e) => {
                                        const outText = e.target.value.replace(/[^ A-Za-z0-9]+/g, '').toUpperCase();
                                        const can_sub = (outText.length>2);
                                        this.setState({search_number: outText, search_name:"", search_ready: can_sub, error: false});
                                    }}
                                    // required
                                    style={{marginBottom:'10px', marginLeft:'10px'}}
                                    disabled={this.state.searching}
                                />
                                <br/>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    type='submit'
                                    disabled={!this.state.search_ready}
                                >
                                    Search
                                </Button>
                                <Button
                                    variant='contained'
                                    onClick={()=>this.setState({selecting_assessor:false,search_name:'',search_ready:false,searching:false,error:false,error_message:'',show_assessors:false, assessor_name: this.props.employee_name, assessor_number:this.props.employee_number})}
                                    style={{marginLeft:'10px'}}
                                    // color='primary'
                                    // type='submit'
                                >
                                    I'm the Assessor
                                </Button>
                                <Button
                                    variant='contained'
                                    onClick={()=>this.setState({selecting_assessor:false,search_name:'',search_number:'',search_ready:false,searching:false,error:false,error_message:'',show_assessors:false})}
                                    style={{marginLeft:'10px'}}
                                    // color='primary'
                                    // type='submit'
                                >
                                    Back
                                </Button>
                            </form>
                        </Grid>
                    </div>}
    
                    {this.state.show_assessors&&
                    <DatasheetView
                        dataset={this.state.assessors_array}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={false}
                        edit={false}
                        handleDelete={null}
                        handleEdit={null}
                        loading={this.state.searching}
                        deleteHeaderName={'Delete'}
                        height={350}
                    />}
                    {/* **End Assessor Selection Panel */}                    

                    <Grid item>
                        <Typography color='secondary' style={{Width:1200,maxWidth:1200, textAlign:'center'}}>{this.state.error_message}</Typography>
                        {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                    </Grid>

                    <Grid
                        container
                        direction='row'
                        alignContent='center'
                        justifyContent='center'
                        style={{width:'1050px'}}
                    >
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={this.props.returnToParent}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                        >
                            Cancel
                        </Button>
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={!this.state.partially_complete}
                            onClick={this.resetMe}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                        >
                            Reset
                        </Button>
                        <Button 
                            color='primary'
                            variant='contained'
                            disabled={!(this.state.has_comment&&this.state.all_answered)||this.state.writing}
                            style={{marginTop:'20px',marginBottom:'10px'}}
                            onClick={this.submitMe}
                        >
                            {this.state.primary_button_text}
                        </Button>
                    </Grid>
                </Grid>
                </Paper>}

                {this.state.querying&&  
                <div className='pageContainer' style={{minHeight:'70vh'}}>
                <div>
                    <Settings className='icn-spinner' /> Building Competency Questionnaire...
                </div>
                </div>}

                {this.state.writing&&            
                <div className='pageContainer' style={{minHeight:'70vh'}}>
                <div>
                    <Settings className='icn-spinner' /> Submitting...
                </div>
                </div>}

                <br/><br/>
            </div>
        );
    }
    
}